import store from '@ps/store'
import { Event, EventBus } from '@ps/utils/event-bus'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { nodeTypes } from '@ps/bridge/qc/scripts/editor'
// import gameIframe from '@ps/qc/iframe'
// import { resetAndStopAnimation } from '@ps/qc/node'
import { generateUUID } from '@ps/utils/game'
import { resetNodeDefaultLayout } from '@ps/bridge/qc/node/utils'
export default function({ state, rootState }, { node }) {
  const scene = rootState.workspace.game.sceneManager.currentSceneNode
  const gameOb = state.data.gameOb
  const atlasKey = `snapshot_${generateUUID()}`
  node.snapshotAsAtlas(atlasKey)
  const res = gameOb.assets.find(atlasKey)
  const cloneNode = gameOb.add.image(scene)
  const editorData = editorScript.getScript(cloneNode)
  editorData.$data.nodeType = nodeTypes.tweenPositionArea
  resetNodeDefaultLayout(cloneNode)
  cloneNode.texture = res
  cloneNode.name = 'tween_position_area'
  cloneNode.width = node.width
  cloneNode.height = node.height
  cloneNode.alpha = 0.5
  store.dispatch('workspace/stage/addVirtualNode', cloneNode)
  EventBus.$emit(Event.ADD_GAME_OBJECT, cloneNode.uuid)
  return cloneNode.uuid
}
